import React from "react";
import PropTypes from "prop-types";


function RadioBtn(Props) {
    const {
        type,
        id,
        className,
        preIconClass,
        postIconClass,
        postTextClass,
        placeholder,
        handleChange,
        onIconClick,
        name,
        value,
        title,
        pattern,
        onFocus,
        alt,
        readOnly,
        required,
        onKeyDown,
        checked,
        handleClick,
        radioLabel
    } = Props;

    return (
        <>
        <input type={type} name={name} id={id} checked={checked} onClick={handleClick} onChange={handleChange}/>
        <span>{radioLabel}</span>
        </>
    );
}

RadioBtn.propTypes = {
    type: PropTypes.string,
    className: PropTypes.string,
    preIconClass: PropTypes.string,
    postIconClass: PropTypes.string,
    labelClass: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string,
    pattern: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    label: PropTypes.string,
    placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    handleChange: PropTypes.func,
    onIconClick: PropTypes.func,
    onFocus: PropTypes.func,
    readOnly: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    required: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    alt: PropTypes.string,
    onKeyDown: PropTypes.func,
    labelIcon: PropTypes.string,
    postTextClass: PropTypes.string,
    checked:PropTypes.bool,
    handleClick:PropTypes.func,
    radioLable:PropTypes.string,
    id:PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

RadioBtn.defaultProps = {
    type: "text",
    className: "form-control grey-input with_icon",
    preIconClass: "",
    postIconClass: "",
    label: "label",
    placeholder: "",
    handleChange: () => null,
    onIconClick: () => null,
    name: "",
    labelClass: "hidden",
    value: "",
    alt: "no-img",
    pattern: null,
    title: null,
    readOnly: false,
    required: false,
    onFocus: () => null,
    onKeyDown: () => null,
    labelIcon: "",
    errors: "",
    propTypes: "",
    onMouseEnter: () => null,
    checked:false,
    handleClick:()=>null,
    radioLabel:'',
    id:null
};

export default RadioBtn;
